import $ from 'jquery';
import {Dialog} from "../Libraries/Dialog";
import {preventWrap, wait, nextFrame} from "../Libraries/Utils";

const $compass = $('#themenkompass');
const $compassHeaderLine = $compass.find('.compass__header-line');
const $compassHeader = $compass.find('.compass__header-text');
const $compassBack = $compass.find('.compass__back');
const $compassTiles = $compass.find('.compass__tiles');
const $compassPages = $compass.find('.compass__page');

let compassState = 'overview';

$(document).on('click', '.themenkompass-open', ev => {
    const dialog = new Dialog({
        type: 'inline',
        closeButton: $compass.find('.compass__close'),
        items: [{
            src: $compass,
        }]
    });

    dialog.$el.on('dialog:beforeOpen', ev => {
        compassState = 'overview';
        $compassHeaderLine.removeClass('mb-0');
        $compassHeader.removeClass('opacity-0');
        $compassBack.addClass('opacity-0');
        $compassTiles.removeClass('opacity-0');
        $compassTiles.removeClass('d-none');
        $compassPages.addClass('d-none');
        $compassPages.addClass('opacity-0');

        $compass.find('.js-load-compass-page').off('click').on('click', preventWrap(async ev => {
            if (compassState === 'page') {
                return;
            }
            compassState = 'page';

            const $link = $(ev.currentTarget);
            const selector = $link.attr('href');
            const $page = $(selector);

            $compassTiles.addClass('opacity-0');
            $compassHeader.addClass('opacity-0');
            $compassHeaderLine.addClass('mb-0');

            await wait(300);

            $compassTiles.addClass('d-none');
            $page.removeClass('d-none');
            $page.addClass('opacity-0');

            await nextFrame();

            $page.removeClass('opacity-0');
            $compassBack.removeClass('opacity-0');
        }));

        $compass.find('.js-compass-back').off('click').on('click', preventWrap(async ev => {
            if (compassState === 'overview') {
                return;
            }
            compassState = 'overview';

            $compassPages.addClass('opacity-0');
            $compassBack.addClass('opacity-0');

            await wait(300);

            $compassHeaderLine.removeClass('mb-0');
            $compassPages.addClass('d-none');

            $compassTiles.addClass('opacity-0');
            $compassTiles.removeClass('d-none');

            await nextFrame();

            $compassTiles.removeClass('opacity-0');
            $compassHeader.removeClass('opacity-0');

        }));

    });

    dialog.open();
});
